import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { SzamlazoService } from '../szamlazo.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

/*  SZÁMLÁK és DÍJBEKÉRŐK (a fül az útvonalból: data.tipus). Lista + szerkesztő ablak.
 *
 *  Életút: piszkozat (szerkeszthető, törölhető) → KIÁLLÍTÁS (sorszám, a NAV-hoz megy) → sztornó.
 *  Díjbekérő: kiállítás (nem megy a NAV-hoz) → befizetéskor „Számla a díjbekérőből" → a kész
 *  számlát kiállítva a díjbekérő teljesített; vagy érvénytelenítés.
 *  Könyvelői nézetben (szerep: konyvelo) minden csak olvasható – a kiszolgáló is tiltja az írást.
 *  A számítás (nettó → áfa → bruttó, forintnál egészre) a kiszolgálóé (szamlazo-nav.js); itt csak
 *  előnézet ugyanazzal a szabállyal. */
@Component({
  selector: 'app-szamlazo-szamlak',
  templateUrl: './szamlak.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../szamlazo-shared.scss'],
})
export class SzamlakComponent implements OnInit, OnDestroy {
  tipus: 'szamla' | 'dijbekero' | 'nyugta' | 'arajanlat' | 'megrendeles' | 'szallitolevel' = 'szamla';
  readonly ELOZETES = ['arajanlat', 'megrendeles', 'szallitolevel'];
  get elozetes(): boolean { return this.ELOZETES.includes(this.tipus); }
  jelentesek: any[] = [];          // nyugtáknál: a napi NAV-adatszolgáltatások
  lista: any[] = [];
  betolt = false;
  kereso = '';
  allapotSzuro = '';
  partnerek: any[] = [];
  termekek: any[] = [];
  szerk: any = null;              // a szerkesztő ablak adata
  fut = false;
  zar: SzerkZar | null = null;    // a nyitott piszkozat szerkesztési zárja
  private zarKor = 0;
  private vege = false;

  private sub?: Subscription;
  private rsub?: Subscription;
  constructor(public sz: SzamlazoService, private route: ActivatedRoute, private toast: ToastController, private alert: AlertController,
              private szerkZar: SzerkZarService) {}

  get u() { return this.sz.aktiv.ugyfelId; }
  get ir() { return this.sz.ir; }
  get cim() { return ({ dijbekero: 'Díjbekérők', nyugta: 'Nyugták', arajanlat: 'Árajánlatok', megrendeles: 'Megrendelések', szallitolevel: 'Szállítólevelek' } as any)[this.tipus] || 'Számlák'; }
  readonly TIPUS_NEV: Record<string, string> = { szamla: 'Számla', dijbekero: 'Díjbekérő', storno: 'Sztornó számla', nyugta: 'Nyugta', nyugta_storno: 'Érvénytelenítő bizonylat',
    arajanlat: 'Árajánlat', megrendeles: 'Megrendelés', szallitolevel: 'Szállítólevél' };
  get ujNev(): string { return 'Új ' + (this.TIPUS_NEV[this.tipus] || 'számla').toLowerCase(); }

  async ngOnInit() {
    await this.sz.init();
    this.rsub = this.route.data.subscribe((d) => { this.tipus = (['dijbekero', 'nyugta', ...this.ELOZETES].includes(d?.['tipus']) ? d['tipus'] : 'szamla'); this.frissit(); });
    this.sub = this.sz.aktiv$.subscribe(() => this.frissit());
  }
  ngOnDestroy() { this.vege = true; this.sub?.unsubscribe(); this.rsub?.unsubscribe(); this.zarElenged(); }

  async frissit() {
    if (!this.u) { this.lista = []; return; }
    this.betolt = true;
    try {
      const tip = this.tipus === 'nyugta' ? 'nyugta,nyugta_storno' : this.tipus === 'szamla' ? 'szamla,storno' : this.tipus;
      const r: any = await this.sz.get(`/szamlak/${this.u}?tipus=${tip}&ev=${this.sz.aktiv.ev}`);
      this.lista = r.szamlak || [];
      this.jelentesek = this.tipus === 'nyugta' ? await this.sz.get(`/nyugta-jelentesek/${this.u}?ev=${this.sz.aktiv.ev}`).catch(() => []) : [];
    } catch (e: any) { this.lista = []; this.hiba(e?.error?.error || 'Nem sikerült betölteni.'); }
    finally { this.betolt = false; }
  }

  get lathato(): any[] {
    const k = this.kereso.trim().toLowerCase();
    return this.lista.filter((s) => (!this.allapotSzuro || s.allapot === this.allapotSzuro || s.nav_allapot === this.allapotSzuro)
      && (!k || String(s.szamlaszam || '').toLowerCase().includes(k) || String(s.vevo_nev || '').toLowerCase().includes(k)));
  }
  get osszesen(): number { return this.lathato.filter((s) => s.allapot !== 'piszkozat' && s.allapot !== 'ervenytelen').reduce((n, s) => n + Number(s.brutto || 0), 0); }

  jelentesNev(a: string): string {
    return ({ kesz: 'beküldve', var: 'beküldésre vár', hiba: 'hiba', nyitott: 'a nap még tart', valtozott: 'változott – módosítás megy', kihagyva: 'nem ez a program küldi' } as any)[a] || a;
  }
  jelentesSzin(a: string): string { return ({ kesz: 'kesz', var: 'var', nyitott: 'piszkozat', valtozott: 'var', hiba: 'hiba', kihagyva: 'kihagyva' } as any)[a] || a; }
  async jelentesKuld(j: any) {
    try {
      const r: any = await this.sz.post(`/nyugta-jelentes/${this.u}/${j.nap}`, {});
      if (r.ok) this.ok(`${j.nap}: beküldve a NAV-nak (${r.nav_id}).`); else this.hiba(`${j.nap}: ${r.uzenet || r.allapot}`);
      await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült a beküldés.'); }
  }
  allapotNev(s: any): string {
    return ({ piszkozat: 'piszkozat', kiallitva: ['dijbekero', ...this.ELOZETES].includes(s.tipus) ? 'nyitott' : 'kiállítva', sztornozott: 'sztornózva',
      teljesitett: s.tipus === 'dijbekero' ? 'számlázva' : 'teljesítve', ervenytelen: 'érvénytelen', ae_fuggo: 'e-pénztárgépre vár' } as any)[s.allapot] || s.allapot;
  }
  navNev(a: string): string {
    return ({ nincs: '–', var: 'vár', bekuldve: 'feldolgozás', kesz: 'befogadva', figyelmeztetes: 'figyelmeztetés', hiba: 'hiba', kihagyva: 'nem küldött' } as any)[a] || a;
  }
  lejart(s: any): boolean { return s.allapot === 'kiallitva' && !s.kiegyenlitve && s.fizhat && s.fizhat < this.ma(); }

  /* ── szerkesztő ── */
  private async torzsBetolt() {
    try { this.partnerek = (await this.sz.get<any[]>(`/partnerek/${this.u}`)).filter((p) => Number(p.aktiv)); } catch { this.partnerek = []; }
    try { this.termekek = (await this.sz.get<any[]>(`/termekek/${this.u}`)).filter((t) => Number(t.aktiv)); } catch { this.termekek = []; }
  }
  async uj() {
    this.zarElenged();
    await this.torzsBetolt();
    this.szerk = { id: null, tipus: this.tipus, allapot: 'piszkozat', partner_id: null, vevo: { tipus: 'belfoldi', orszag: 'HU' },
      kelt: this.ma(), teljesites: this.ma(), fizhat: '', fizmod: 'TRANSFER', penznem: 'HUF', arfolyam: 1, megjegyzes: '',
      tetelek: [this.ujSor()] };
  }
  async nyit(s: any) {
    try {
      const [r] = await Promise.all([this.sz.get(`/szamla/${this.u}/${s.id}`), this.torzsBetolt()]);
      this.szerk = { ...r, eredeti_szam: s.eredeti_szam, storno_szam: s.storno_szam, vegszamla_szam: s.vegszamla_szam };
      this.zarFoglal(this.szerk);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült megnyitni.'); }
  }
  /*  SZERKESZTÉSI ZÁR (components/szerk-zar): csak a piszkozatra – a kiállított bizonylat úgyis csak
   *  olvasható. A késve megjött zárat (közben bezárták, másikat nyitottak) rögtön elengedjük. */
  private async zarFoglal(sz: any) {
    this.zarElenged();
    if (this.vege || !this.ir || sz?.allapot !== 'piszkozat' || !sz.id) return;
    const id = String(sz.id), kor = this.zarKor;
    const z = await this.szerkZar.foglal('szamlazo', 'szamlazo_szamla', id, { ujratolt: () => this.ujratolt(id) });
    if (kor !== this.zarKor || this.vege || String(this.szerk?.id) !== id) { z?.felenged(); return; }
    this.zar = z;
  }
  private zarElenged() { this.zarKor++; this.zar?.felenged(); this.zar = null; }
  /** A szerkesztő bezárása (Bezár, az ablak eltűnése). */
  bezar() { this.szerk = null; this.zarElenged(); }
  //  A zár felszabadult / a sáv újratöltése: a friss piszkozat, az ablak nyitva marad.
  private async ujratolt(id: string) {
    const r: any = await this.sz.get(`/szamla/${this.u}/${id}`);
    const sz = this.szerk;
    if (String(sz?.id) !== id) return;
    this.szerk = { ...r, eredeti_szam: sz.eredeti_szam, storno_szam: sz.storno_szam, vegszamla_szam: sz.vegszamla_szam };
    if (this.szerk.allapot !== 'piszkozat') this.zarElenged();   // közben kiállították – már csak olvasható
  }
  get szerkesztheto(): boolean { return this.ir && this.szerk?.allapot === 'piszkozat'; }
  ujSor() { return { megnevezes: '', fajta: 'SERVICE', mennyiseg: 1, egyseg: 'db', egysegar: 0, afa_kulcs: '27' }; }
  sorHozzaad() { this.szerk.tetelek.push(this.ujSor()); }
  sorTorol(i: number) { this.szerk.tetelek.splice(i, 1); if (!this.szerk.tetelek.length) this.sorHozzaad(); }
  termekValaszt(t: any, termekId: string) {
    const p = this.termekek.find((x) => x.id === termekId);
    if (!p) return;
    Object.assign(t, { termek_id: p.id, megnevezes: p.nev, fajta: p.fajta, egyseg: p.egyseg, egysegar: Number(p.egysegar), afa_kulcs: p.afa_kulcs });
  }
  partnerValaszt(id: string) {
    const p = this.partnerek.find((x) => x.id === id);
    this.szerk.partner_id = p?.id || null;
    if (p) this.szerk.vevo = { nev: p.nev, tipus: p.tipus, adoszam: p.adoszam, kozossegi_adoszam: p.kozossegi_adoszam, orszag: p.orszag,
      irsz: p.irsz, telepules: p.telepules, cim: p.cim, email: p.email };
  }

  /*  Előnézeti számítás – ugyanaz a szabály, mint a kiszolgálón: nettó = menny × egységár (forintnál
   *  egészre kerekítve), áfa = nettó × kulcs (kerekítve), bruttó = nettó + áfa. */
  private kerek(v: number) { const t = this.szerk?.penznem === 'HUF' ? 1 : 100; return Math.round((Number(v) || 0) * t) / t; }
  private szazalek(k: string): number { return ({ '27': 27, '18': 18, '5': 5 } as any)[k] || 0; }
  sorNetto(t: any) { return this.kerek(Number(t.mennyiseg) * Number(t.egysegar)); }
  sorAfa(t: any) { return this.kerek(this.sorNetto(t) * this.szazalek(t.afa_kulcs) / 100); }
  sorBrutto(t: any) { return this.sorNetto(t) + this.sorAfa(t); }
  get szNetto() { return (this.szerk?.tetelek || []).reduce((n: number, t: any) => n + this.sorNetto(t), 0); }
  get szAfa() { return (this.szerk?.tetelek || []).reduce((n: number, t: any) => n + this.sorAfa(t), 0); }

  async ment(utana?: 'kiallit' | 'elonezet') {
    const s = this.szerk;
    if (this.zar && !this.zar.irhato) return;
    if (!String(s.vevo?.nev || '').trim()) return this.hiba('Válassz vevőt, vagy add meg a nevét.');
    this.fut = true;
    try {
      const uj = !s.id;
      const r: any = await this.sz.post(`/szamla/${this.u}`, s);
      s.id = r.id;
      //  Az első mentés után már létező piszkozat: ha nyitva marad, zárat kap.
      if (uj && utana !== 'kiallit' && this.szerk === s) this.zarFoglal(s);
      if (utana === 'kiallit') {
        const k: any = await this.sz.post(`/szamla/${this.u}/${r.id}/kiallit`, {});
        this.ok(`Kiállítva: ${k.szamlaszam}${k.nav === 'kesz' || k.nav === 'bekuldve' ? ' – beküldve a NAV-nak' : k.nav === 'hiba' ? ' – a NAV-beküldés hibás, nézd meg a listában' : k.nav === 'var' ? ' – a NAV-beküldés folyamatban' : ''}.`);
        this.bezar();
      } else if (utana === 'elonezet') {
        await this.sz.pdf(r.id, 'Előnézet');
      } else this.ok('Piszkozat mentve.');
      await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
    finally { this.fut = false; }
  }
  async kiallit() {
    if (this.zar && !this.zar.irhato) return;
    const a = await this.alert.create({ header: this.tipus === 'dijbekero' ? 'Díjbekérő kiállítása' : 'Számla kiállítása',
      message: this.tipus === 'dijbekero' ? 'A díjbekérő sorszámot kap. Nem számla, a NAV-hoz nem megy.'
        : 'A számla sorszámot kap, és a NAV-hoz kerül. Kiállítás után nem módosítható, csak sztornózható. Folytatod?',
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Kiállítás', handler: () => { this.ment('kiallit'); } }] });
    await a.present();
  }
  async torol() {
    if (this.zar && !this.zar.irhato) return;
    const a = await this.alert.create({ header: 'Piszkozat törlése', message: 'Törlöd a piszkozatot?',
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => {
        try { await this.sz.del(`/szamla/${this.u}/${this.szerk.id}`); this.bezar(); await this.frissit(); this.ok('Törölve.'); }
        catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
      } }] });
    await a.present();
  }

  /*  BIZONYLATLÁNC: a kiállított bizonylatból a következő piszkozata (a tételekkel) – rögtön megnyílik. */
  async atalakit(s: any, cel: string) {
    try {
      const r: any = await this.sz.post(`/szamla/${this.u}/${s.id}/atalakit`, { cel });
      await this.torzsBetolt();
      this.szerk = await this.sz.get(`/szamla/${this.u}/${r.id}`);
      this.zarFoglal(this.szerk);
      this.ok(`${this.TIPUS_NEV[cel]} piszkozata elkészült – nézd át, és állítsd ki.`);
      await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }
  /*  KIEGYENLÍTÉS részletekben. */
  befizetes: any = null;
  befizetesNyit(s: any) { this.befizetes = { datum: this.ma(), osszeg: Math.round((Number(s.brutto) - Number(s.fizetve || 0)) * 100) / 100, fizmod: s.fizmod, megjegyzes: '' }; }
  async befizetesMent() {
    try {
      const r: any = await this.sz.post(`/szamla/${this.u}/${this.szerk.id}/kiegyenlites`, this.befizetes);
      this.befizetes = null; this.ok(r.teljes ? 'Kiegyenlítve.' : 'Részlet rögzítve.');
      this.szerk = await this.sz.get(`/szamla/${this.u}/${this.szerk.id}`); await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }
  async befizetesTorol(k: any) {
    try { await this.sz.del(`/kiegyenlites/${this.u}/${k.id}`); this.szerk = await this.sz.get(`/szamla/${this.u}/${this.szerk.id}`); await this.frissit(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }
  get gyariszamOszlop(): boolean { return ['szallitolevel', 'szamla', 'megrendeles'].includes(this.szerk?.tipus); }
  hataridoNev(t: string): string { return t === 'arajanlat' ? 'Érvényes eddig' : t === 'megrendeles' ? 'Száll. határidő' : 'Határidő'; }

  /* ── műveletek a kiállított bizonylaton ── */
  pdf(s: any) { this.sz.pdf(s.id, s.szamlaszam || 'Számla'); }
  async storno(s: any) {
    const a = await this.alert.create({ header: `${s.tipus === 'nyugta' ? 'Érvénytelenítés' : 'Sztornó'}: ${s.szamlaszam}`,
      message: s.tipus === 'nyugta' ? 'A nyugtát egy mai keltű érvénytelenítő bizonylat ellentételezi; a napi nyugta-adatszolgáltatásban módosító bizonylatként szerepel.'
        : 'A teljes számla ellentételezése egy új, negatív sztornó számlával (a NAV-hoz is megy). A helyes adatokkal utána új számlát állíthatsz ki.',
      inputs: [{ name: 'indok', type: 'text', placeholder: 'Indok (a sztornó számlán megjelenik)' }],
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: s.tipus === 'nyugta' ? 'Érvénytelenítés' : 'Sztornózás', role: 'destructive', handler: async (v: any) => {
        try { const r: any = await this.sz.post(`/szamla/${this.u}/${s.id}/storno`, { indok: v?.indok }); this.ok(`Sztornó kiállítva: ${r.szamlaszam}.`); this.szerk = null; await this.frissit(); }
        catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült sztornózni.'); }
      } }] });
    await a.present();
  }
  async kiegyenlit(s: any, rendezve: boolean) {
    try {
      await this.sz.post(`/szamla/${this.u}/${s.id}/kiegyenlit`, { datum: rendezve ? this.ma() : null });
      this.ok(rendezve ? 'Kiegyenlítettnek jelölve.' : 'A kiegyenlítés törölve.'); await this.frissit();
      if (this.szerk?.id === s.id) this.szerk.kiegyenlitve = rendezve ? this.ma() : null;
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }
  async szamlava(s: any) {
    try {
      const r: any = await this.sz.post(`/szamla/${this.u}/${s.id}/szamlava`, {});
      this.ok('A számla piszkozata elkészült – nézd át, és állítsd ki (a Számlák között).');
      this.bezar();
      this.tipus = 'szamla';
      await this.torzsBetolt();
      this.szerk = await this.sz.get(`/szamla/${this.u}/${r.id}`);
      this.zarFoglal(this.szerk);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }
  async ervenytelenit(s: any) {
    const a = await this.alert.create({ header: 'Díjbekérő érvénytelenítése', message: `Érvényteleníted: ${s.szamlaszam}?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Érvénytelenítés', role: 'destructive', handler: async () => {
        try { await this.sz.post(`/szamla/${this.u}/${s.id}/ervenytelenit`, {}); this.szerk = null; await this.frissit(); this.ok('Érvénytelenítve.'); }
        catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
      } }] });
    await a.present();
  }
  async nav(s: any) {
    try {
      const r: any = await this.sz.post(`/szamla/${this.u}/${s.id}/nav`, {});
      this.ok(`NAV: ${this.navNev(r.nav_allapot)}${r.nav_uzenet ? ' – ' + r.nav_uzenet : ''}`); await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült a NAV-művelet.'); }
  }

  ma(): string { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; }
  szam(v: any, p = 'HUF'): string { const n = Number(v); return isFinite(n) ? n.toLocaleString('hu-HU', { maximumFractionDigits: p === 'HUF' ? 0 : 2 }) : ''; }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 3200, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 4500, color: 'danger' })).present(); }
}
